import React, { useState, useEffect }  from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { formatPrice, getLang, convertNum, getProvince } from '../../../utils'

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import NavHelper from '../../../Helpers/navhelper';
import { openModal, scrollTo } from '../../../Helpers/helpers';
import GTMHelper from '../../../Helpers/gtmHelper';

import Button from '../../1_Atoms/Button/Button';

export const Pricing = ({ builtLabel, builtPrice, loanLabel, loanPrice, buttonLabel, leaseLabel, financeLabel, HandleNextClick, setLegalModalOpen, HandleShowFinanceClick, saveLabel, summaryCalculator = window.summaryCalculator, setPreorderModalOpen, ...props }) => {
    //const summaryCalculator = window.summaryCalculator;
    const { year, carline, trim, model, packageCode } = useParams();

    const lang= getLang();
    const navigate = useNavigate();
    const navHelper = new NavHelper();

    const [financialInfo, setFinancialInfo] = React.useState(summaryCalculator.FinancialInfo);
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);
    const [currentMileage] = React.useState(summaryCalculator.AnnualMileage);
    const includeFees = sessionStorage.getItem(Constants.IncludeFees) === 'true';
    const includeRebates = sessionStorage.getItem(Constants.IncludeRebates) === 'true';
    const includeTaxes = sessionStorage.getItem(Constants.IncludeTaxes) === 'true';
    const app = document.querySelector('.App');
    const { t, i18n } = useTranslation(['general']);
    const resizeObserver = new ResizeObserver(() => {
        calculatePriceBarPosition();
    })
    const mazdaFooter = document.querySelector('.mz-footer');
    const mazdaPricing = document.querySelector('.mz-pricing');
    const scrollElement = document.querySelector('.scroll-content');
	const gtmHelper = new GTMHelper();

    const [ocaOpen, setOcaModalOpen] = React.useState(false);
    const [financeType, setFinanceType] = React.useState(false);
    
    const [searchParams, setSearchParams] = useSearchParams();

    const [update, setForceUpdate] =  useState('');

    window.removeEventListener('scroll', calculatePriceBarPosition);
    window.removeEventListener('resize', calculatePriceBarPosition);

    if (resizeObserver && app)
        resizeObserver.unobserve(app);

    if (mazdaFooter && mazdaPricing) {
        window.addEventListener('scroll', calculatePriceBarPosition, false);
        window.addEventListener('resize', calculatePriceBarPosition, false);
        resizeObserver.observe(app);
    }

    function calculatePriceBarPosition(e) {
        if (!scrollElement) {
            if (!isFooterOnViewport()) {
                mazdaPricing.style.bottom = "0px";
            } else {
                mazdaPricing.style.bottom = `${howMuchFooterIsVisible()}px`;
            }
        } else {
            if (isFooterOnViewport()) {
                mazdaPricing.style.bottom = `${mazdaFooter.offsetHeight}px`;
            } else {
                mazdaPricing.style.bottom = `${scrollElement.clientHeight - window.innerHeight - parseFloat(window.getComputedStyle(scrollElement).transform.split(", ")[5].replace(')', '')) * -1}px`;
            }
        }

    }


    function handleTogglePrice(e) {
        e.preventDefault();
        //const auxshowFinancePrice = !showFinancePrice
        summaryCalculator.ShowFinancePrice = !showFinancePrice;
        setShowFinancePrice(summaryCalculator.ShowFinancePrice);


        if(HandleShowFinanceClick)
            HandleShowFinanceClick(summaryCalculator.ShowFinancePrice);

		const toggleType = summaryCalculator.ShowFinancePrice === false ? 'lease':'finance'
		gtmHelper.setGTM({'action':'Switch Financing','finance type': toggleType}, true, false);
    }

    function isFooterOnViewport() {
        const { top, bottom } = mazdaFooter.getBoundingClientRect()
        const vHeight = (window.innerHeight || document.documentElement.clientHeight);

        return (
            (top > 0 || bottom > 0) &&
            top < vHeight
        );
    }

    function howMuchFooterIsVisible() {
        var distance = 0;
        let elem = document.querySelector('.mz-footer');
        const vHeight = window.innerHeight;
        const scrollPosition = window.pageYOffset | document.body.scrollTop;
        do {
            distance += elem.offsetTop;
            elem = elem.offsetParent;
        } while (elem);

        if (scrollPosition > (distance - vHeight)) {
            return scrollPosition - (distance - vHeight);
        } else {
            return 0;
        }
    }

    function handlePreOrderClick() {
        document.querySelector('body').classList.add('disabled');
        setPreorderModalOpen(true);
        
    }

    function handleContactDealerLinkClick(e) {
        e.preventDefault();
        console.log(lang)
        gtmHelper.setGTM({'action':'Open Modal','modal': 'Contact Dealer'}, true, false);
        const targetModal = document.getElementById('mz-react-send-build-to-dealer-modal');
        if (targetModal && summaryCalculator) {
            if (summaryCalculator.SelectedColourExteriorIndex !== 'null' && summaryCalculator.Colours !== null) {
                const heading = targetModal.querySelector('.mz-send-build-to-dealer__vehicle-name');
                if (heading) {
                    heading.textContent = lang === 'en' ? summaryCalculator._selectedModelYear.year.title + ' ' + ReactHtmlParser(summaryCalculator._selectedModelYear.carline.title) : ReactHtmlParser(summaryCalculator._selectedModelYear.carline.title) + ' ' + summaryCalculator._selectedModelYear.year.title;
                }
            }
            openModal('mz-react-send-build-to-dealer-modal');
        }
    }

    const handleOcaClick = (e) => {
        e.preventDefault();
        document.querySelector('body').classList.remove('disabled');
        if (window.location.href.indexOf('/payments') > 0) {
            setSearchParams({'oca':''});
            setTimeout(() => {
                setSearchParams({'oca':'1'});
            }, 10);
        }else{
            navigate(navHelper.getNavContent(t).tabList[5].uri + '&oca=1');
        }
        const price = summaryCalculator._showFinancePrice ? summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinanceWithFeesWithRebatesTaxed : summaryCalculator.FinancialInfo.calculatedLease.balanceToLeaseWithFeesWithRebatesTaxed;
        gtmHelper.setGTM({'action':`OCA - Footer`,'year': year, 'model': carline, 'trim': summaryCalculator.selectedVehicle.trim ?? summaryCalculator.AvailableTrim.trims[0].trim_type.url_slug, 'price' : Math.round(price)}, true, false);
    }

    const getLoanRate = () => {
        if(summaryCalculator.getResponsesHasError())
            return '-'; 

        const loanElement = summaryCalculator.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex];
        if (Number.parseFloat(loanElement.aprRate) !== Number.parseFloat(loanElement.aprRateDiscounted))
            return convertNum(loanElement.aprRateDiscounted,2) + '%';
        else
            return convertNum(loanElement.aprRate,2) + '%';
    }

    const getLeaseRate = () => {
        if(summaryCalculator.getResponsesHasError())
            return '-';

        const leaseElement = summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex];
        if (Number.parseFloat(leaseElement.leaseRate) !== Number.parseFloat(leaseElement.leaseRateDiscounted))
            return convertNum(leaseElement.leaseRateDiscounted,2) + '%';
        else
            return convertNum(leaseElement.leaseRate,2) + '%';
    }

    const getLoanWeekly = () => {
        if(summaryCalculator.getResponsesHasError())
            return '-';

        const loanElement = financialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex];
        const weeklyPayment = loanElement[summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly'];

        if( weeklyPayment === 0 || weeklyPayment === '0')
            return '-';

        return formatPrice(weeklyPayment);
    }

    const getLeaseWeekly = () => {
        if(summaryCalculator.getResponsesHasError())
            return '-';
                
        const leaseElement = financialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex]
        const weeklyPayment = leaseElement[summaryCalculator.IncludeTaxes ? 'biWeeklyWithTaxes' : 'biWeekly'];

        if( weeklyPayment === 0 || weeklyPayment === '0')
            return '-';

        return formatPrice(weeklyPayment);

    }    

    function getQCEVDisclaimerSection(){
        if(summaryCalculator.IncludeRebates && getProvince() === 'QC' && summaryCalculator.FinancialInfo?.ev_rebates?.length){
             return (
                 <>  
                     <div class="mz-QC-EV-disclaimer text--grey label">
                         {ReactHtmlParser(t("general:QCEVDisclaimer"))}
                         
                     </div>
                     
                 </>
             )
        }
     }
     function handleQCEVD_LinkClick(e){
        if(e.target.id === 'QCEVD_link'){
            e.preventDefault();
            const contactRoute = `/${year}/${carline}/${summaryCalculator.SelectedTrim.trim_type.url_slug}/${summaryCalculator.SelectedModel.model_code}/${summaryCalculator.SelectedModel.option_code}/summary?contactDealer`;
            navigate(contactRoute);
        }
     }

     function hasBreak(){
        if(lang === 'fr')
            return (<br/>)
     }

    function getCashPrice(){
        let financePricing = null;
        let cashPricing = null;
        if(includeFees){
            if(includeTaxes){
                if(includeRebates){
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinanceWithFeesWithRebatesTaxed : financialInfo.calculatedLease.balanceToLeaseWithFeesWithRebatesTaxed;
                    cashPricing = financialInfo.calculatedCash.subtotalWithFeesWithRebatesTaxed;
                }else{
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinanceWithFeesTaxed : financialInfo.calculatedLease.balanceToLeaseWithFees;
                    cashPricing = financialInfo.calculatedCash.subtotalWithFeesTaxed;
                }
            }else{
                if(includeRebates){
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinanceWithFeesWithRebates : financialInfo.calculatedLease.balanceToLeaseWithFeesWithRebates;
                    cashPricing = financialInfo.calculatedCash.subtotalWithFeesWithRebatesAndEvRebates;
                }else{
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinanceWithFees : financialInfo.calculatedLease.balanceToLeaseWithFees
                    cashPricing = financialInfo.calculatedCash.subtotalWithFees;
                }
            }
        }else{
            if(includeTaxes){
                if(includeRebates){
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinanceWithRebatesTaxed : financialInfo.calculatedLease.balanceToLeaseWithRebates;
                    cashPricing = financialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebatesTaxed;
                }else{
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinanceTaxed : financialInfo.calculatedLease.balanceToLease;
                    cashPricing = financialInfo.calculatedCash.subtotalTaxed;
                }
            }else{
                if(includeRebates){
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinanceWithRebates : financialInfo.calculatedLease.balanceToLeaseWithRebates;
                    cashPricing = financialInfo.calculatedCash.subtotalWithIncentiveRebatesAndEvRebates;
                }else{
                    financePricing = showFinancePrice ? financialInfo.calculatedFinance.balanceToFinance : financialInfo.calculatedLease.balanceToLease;
                    cashPricing = financialInfo.calculatedCash.subtotal;
                }
            }
        }

        //for get local price form to grab
        summaryCalculator.CurrentCalculatedCash = formatPrice(cashPricing, true);

        return (<span className='mmz-cahs-options__price'>{formatPrice(financePricing)}</span>);
    }
    React.useEffect(() => {
        (async () => {
            if(summaryCalculator._selectedModel !== null) {
                document.addEventListener('click',handleQCEVD_LinkClick);
                
                setFinancialInfo(await summaryCalculator.RecalculateFinancialInfo());
        
                setForceUpdate(Math.random());
            }
        })();
    }, [
        summaryCalculator.FinancialInfo?.calculatedFinance, 
        summaryCalculator.FinancialInfo?.calculatedLease,
        summaryCalculator._tradeInValue, 
        summaryCalculator._downPaymentValue,
        summaryCalculator.LoyaltyChecked, 
        summaryCalculator.GraduateChecked, 
        summaryCalculator.MilitaryChecked,
        summaryCalculator.FirstTimeOwnerChecked,
    ]);

    useEffect(() => {
        console.log('refreshing pricebar section');
    }, [update]);
    
    if(!financialInfo)
        return (<></>);
    else
    return (
        <>
            <div
                className='mz-pricing'
                {...props}
            >
                <Button
                    className="mz-btn mz-btn--legal text--grey"
                    label={t("general:legal")}
                    backgroundColor="grey"
                    colour="grey"
                    icon={true}
                    iconAfter={true}
                    svg_className=""
                    svg_list="plus"
                    size={0.6}
                    onClick={() => {
                        document.querySelector('body').classList.add('disabled');
                        setLegalModalOpen(true)
                        gtmHelper.setGTM({'action':'Open Modal','modal': 'legal'}, true, false);
                    }}
                />            
                <div className="mz-pricing__container">
                    <div className="mz-pricing__built">{builtLabel}<span className="mz-pricing__built--price">
                        {getCashPrice()}
                    </span></div>
                    <div className="mz-pricing__lease">
                        {showFinancePrice ? t("general:finance") : t("general:lease")}: {showFinancePrice ? summaryCalculator.FinanceTerm : summaryCalculator.LeaseTerm}{t("general:pricing_bar_label")} {showFinancePrice ? getLoanRate() : getLeaseRate()}

                        <span className="mz-pricing__lease--price">{showFinancePrice ? getLoanWeekly()+t("general:weekly") : getLeaseWeekly()+t("general:bi_weekly")}</span>
                    </div>
                    {window.allow_oca ? 
                    <div className="mz-pricing__options">
                    <div><a className="mz-link label" onClick={(e) => {
                            handleOcaClick(e);
                        }}  >{ReactHtmlParser(t('general:ocaPriceBar'))}</a></div>
                        <a className="mz-link label" href="" onClick={handleTogglePrice}>{showFinancePrice ? leaseLabel : financeLabel}</a>
                    </div> :
                    <div className="mz-pricing__options no_oca" >
                        <a className="mz-link label" href="" onClick={handleTogglePrice}>{showFinancePrice ? leaseLabel : financeLabel}</a>
                    </div>
                    }
                    <Button
                        className="mz-btn mz-btn--primary mz-btn--red"
                        primary={true}
                        backgroundColor="red"
                        colour="white"
                        label={buttonLabel}
                        icon={true}
                        iconAfter={true}
                        svg_className=""
                        svg_list="chevron_small"
                        size={0.8}
                        onClick={() => {
                            HandleNextClick();
                        }}
                    />
                    <div className="mz-pricing__dealer">
                        <div>
                            {summaryCalculator.isSelectionPreOrder() ?
                            <a className="mz-link label" onClick={handlePreOrderClick} style={{cursor:'pointer'}}>{ReactHtmlParser(t("general:pre_order"))}</a>
                            :
                            <a className="mz-link label" onClick={handleContactDealerLinkClick} style={{cursor:'pointer'}}>{ReactHtmlParser(t("general:get_local_price"))}</a>}
                        </div>
                    </div>
                </div>
                <div className="mz-pricing__built mz-mobile">{ReactHtmlParser(t('general:price_as_built_m'))}
                    <span className="mz-pricing__built--price mz-mobile">
                        {getCashPrice()}
                    </span>
                    <div className="mz-pricing__dealer">
                    {summaryCalculator.isSelectionPreOrder() ?
                        <a className="mz-link label" onClick={handlePreOrderClick} style={{cursor:'pointer'}}>{ReactHtmlParser(t("general:pre_order"))}</a>
                        :
                        <a className="mz-link label" onClick={handleContactDealerLinkClick} style={{cursor:'pointer'}}>{ReactHtmlParser(t("general:get_local_price"))}</a>
                    }
                    </div>
                </div>
                <div className="mz-pricing__lease mz-mobile">
                    {showFinancePrice ? t("general:finance") : t("general:lease")}: {hasBreak()} {showFinancePrice ? summaryCalculator.FinanceTerm : summaryCalculator.LeaseTerm}{t("general:pricing_bar_label")} {showFinancePrice ? getLoanRate() : getLeaseRate()}

                    <span className="mz-pricing__lease--price mz-mobile">{showFinancePrice ? getLoanWeekly()+t("general:weekly") : getLeaseWeekly()+t("general:bi_weekly")}</span>

                    <div>
                        {window.allow_oca ? 
                        <>
                            <a className="mz-link label nowrap" onClick={(e) => handleOcaClick(e)}  >{ReactHtmlParser(t('general:ocaPriceBar'))}</a> 
                            <br/> 
                        </>
                        : "" }
                        <a className="mz-link label nowrap" href="#" onClick={handleTogglePrice}>{showFinancePrice ? leaseLabel : financeLabel}</a></div>
                </div>
            
                <Button
                    className="mz-btn mz-btn--primary mz-btn--red mz-mobile"
                    primary={true}
                    backgroundColor="red"
                    label={buttonLabel}
                    icon={true}
                    iconAfter={true}
                    colour="white"
                    svg_className=""
                    svg_list="chevron_small"
                    size={0.8}
                    onClick={() => HandleNextClick()}
                />
               
            </div>
        </>
     );
};


// Pricing.propTypes = {
//     HandleTabClick: PropTypes.func,
// }

// Pricing.defaultProps = {
//     HandleTabClick: () => {
//     },
// };